export default __webpack_public_path__ + "static/media/2.ef54aa2e.jpg";